import React from 'react';
import PiscineCard from './PiscineCard';
import '../styles/PiscineList.css';

function PiscineList({ piscines, userLocation, desiredTime, jourLabel, selectedDate }) {
  return (
    <div className="piscine-list">
      <h2>{piscines.length} piscine(s) trouvée(s)</h2>
      <div className="cards-grid">
        {piscines.map(piscine => (
          <PiscineCard
            key={piscine.id}
            piscine={piscine}
            userLocation={userLocation}
            desiredTime={desiredTime}
            jourLabel={jourLabel}
            selectedDate={selectedDate}
          />
        ))}
      </div>
    </div>
  );
}

export default PiscineList;
